import React from "react";

// The Eye of Horus must render independently of installed hieroglyph fonts.
export default function JourneyGlyph({ glyph }) {
  if (glyph !== "𓂀") return glyph;
  return <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d="M3 13c7-8 17-8 26 0-8 7-18 7-26 0Zm1-6c8-4 16-4 24 0M15 18v9l-4-4m11-6c5 6-2 12-7 6M3 13l-2 3" />
    <ellipse cx="16" cy="13" rx="3.5" ry="5" fill="currentColor" stroke="none" />
  </svg>;
}
